import React from 'react';
import { ownerTone, type OwnerTone } from '../utils/siteDrillThrough';

const TONE: Record<OwnerTone, string> = {
  info: 'tw-bg-info/15 tw-text-info-text',
  primary: 'tw-bg-primary/10 tw-text-primary-dark',
  muted: 'tw-bg-surface-hover tw-text-content-secondary',
};

interface OwnerPillProps {
  owner: string | null;
  /** Shown when `owner` is empty. Omit to render nothing for an unowned bin. */
  fallback?: string;
  className?: string;
}

/** Soft owner pill (MoTI blue, DRM brand blue, anything else neutral). */
const OwnerPill: React.FC<OwnerPillProps> = ({ owner, fallback, className = '' }) => {
  const label = owner?.trim() || fallback;
  if (!label) return null;
  return (
    <span
      data-slot="owner-pill"
      className={`tw-inline-block tw-whitespace-nowrap tw-rounded-full tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold ${TONE[ownerTone(owner)]} ${className}`}
    >
      {label}
    </span>
  );
};

export default OwnerPill;
